import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { getFormDateRangeFieldsDefaultTime } from '../helpers/get-form-date-range-fields-default-time';

export function useHandleFormDateRange({
    timeRangeOptionPath,
    dateRangePath,
}: {
    timeRangeOptionPath: string;
    dateRangePath: string;
}) {
    const { form } = useIntegratedForm();
    const timeRange = useWatch({ control: form.control, name: timeRangeOptionPath });
    const dateRange = useWatch({ control: form.control, name: dateRangePath });
    const [showDateRangeInput, setShowDateRangeInput] = useState(false);

    useEffect(() => {
        if (timeRange?.isCustom) {
            if (!dateRange) {
                form.setValue(dateRangePath, getFormDateRangeFieldsDefaultTime());
            }

            setShowDateRangeInput(true);
            return;
        }

        form.resetField(dateRangePath);
        setShowDateRangeInput(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeRange, form, dateRangePath]);

    return { showDateRangeInput };
}
